import { useTranslation } from 'react-i18next';
import { numberToCurrency } from 'utils/translate';
import Chevron from 'assets/icons/chevron-right.svg?react';

export function OriginalAmount({ amount }: { amount?: number }) {
  const { t } = useTranslation('downsale');
  return (
    <div className="flex flex-col items-center lg:items-start">
      <div className="font-medium">{t('prev_amount')}</div>
      <div className="text-4xl font-medium" data-test="original-amount">
        {numberToCurrency(amount)}
      </div>
    </div>
  );
}

export function NewAmount({ amount }: { amount?: number }) {
  const { t } = useTranslation('downsale');
  return (
    <div className="flex flex-col items-center lg:items-start">
      <div className="font-medium text-primary">{t('proposal_amount')}</div>
      <div
        className="text-4xl font-medium text-primary"
        data-test="original-amount"
      >
        {numberToCurrency(amount)}
      </div>
    </div>
  );
}

export default function OriginalAndNewAmount({
  originalAmount,
  newAmount,
}: {
  originalAmount?: number;
  newAmount?: number;
}) {
  return (
    <div className="flex flex-col lg:flex-row items-center gap-1 lg:gap-6">
      <OriginalAmount amount={originalAmount} />
      <Chevron className="rotate-90 lg:rotate-0" />
      <NewAmount amount={newAmount} />
    </div>
  );
}
